import { Layout } from 'components/Layout/Layout';
import { ProtectedLayout } from 'components/Layout/ProtectedLayout';
import { HomePage } from 'pages/Home';
import { LoginPage } from 'pages/Login';
import { createBrowserRouter } from 'react-router-dom';
import { ForgotPasswordPage } from 'pages/ForgotPassword';
import { SetNewPasswordPage } from 'pages/SetNewPassword';
import { SignUpPage } from 'pages/SignUp';
import { DashboardPage } from 'pages/Dashboard';
import { UserProfilePage } from 'pages/UserProfile';
import { AppointmentsPage } from 'pages/Appointments';
import { CreateAppointmentPage } from 'pages/CreateAppointment';
import { EditAppointmentPage } from 'pages/EditAppointment';
import { UsersPage } from 'pages/Users';
import { ViewAppointmentPage } from 'pages/ViewAppointment';
import { ProposalsPage } from 'pages/Proposals';
import { CreateProposalPage } from 'pages/CreateProposal';
import { EditProposalPage } from 'pages/EditProposal';
import { InvoicesPage } from 'pages/Invoices';
import { CreateInvoicePage } from 'pages/CreateInvoice';
import { EditInvoicePage } from 'pages/EditInvoice';
import { CreateUserPage } from 'pages/CreateUser';
import { UpdateUserPage } from 'pages/EditUser';
import { AdminSettingsPage } from 'pages/Admin/AdminSettings';
import { AdminCreateHomeImagesPage } from 'pages/Admin/AdminCreateHomeImages';
import { AdminSettingsHomePageListPage } from 'pages/Admin/HomePageList';
import { AdminEditHomeImagesPage } from 'pages/Admin/AdminEditHomeImages';

import { PATH } from './path';

export const router = createBrowserRouter([
    {
        path: PATH.ROOT,
        element: <ProtectedLayout />,
        children: [
            { path: PATH.USER_PROFILE, element: <UserProfilePage /> },
            { path: PATH.APPOINTMENTS, element: <AppointmentsPage /> },
            { path: PATH.CREATE_APPOINTMENT, element: <CreateAppointmentPage /> },
            { path: PATH.EDIT_APPOINTMENT, element: <EditAppointmentPage /> },
            { path: PATH.APPOINTMENT_DETAILS, element: <ViewAppointmentPage /> },
            { path: PATH.PROPOSALS, element: <ProposalsPage /> },
            { path: PATH.CREATE_PROPOSAL, element: <CreateProposalPage /> },
            { path: PATH.EDIT_PROPOSAL, element: <EditProposalPage /> },
            { path: PATH.INVOICES, element: <InvoicesPage /> },
            { path: PATH.CREATE_INVOICE, element: <CreateInvoicePage /> },
            { path: PATH.EDIT_INVOICE, element: <EditInvoicePage /> },
            { path: PATH.USERS, element: <UsersPage /> },
            { path: PATH.USER_CREATE, element: <CreateUserPage /> },
            { path: PATH.USER_UPDATE, element: <UpdateUserPage /> },
            { path: PATH.ADMIN_SETTINGS, element: <AdminSettingsPage /> },
            { path: PATH.ADMIN_SETTINGS_HOME_PAGE, element: <AdminSettingsHomePageListPage /> },
            { path: PATH.CREATE_HOME_PAGE, element: <AdminCreateHomeImagesPage /> },
            { path: PATH.EDIT_HOME_PAGE, element: <AdminEditHomeImagesPage /> },
        ],
    },
    {
        path: PATH.ROOT,
        element: <Layout />,
        children: [
            { element: <HomePage />, index: true },
            { path: PATH.SIGN_UP, element: <SignUpPage /> },
            { path: PATH.LOGIN, element: <LoginPage /> },
            { path: PATH.FORGOT_PASSWORD, element: <ForgotPasswordPage /> },
            { path: PATH.CHANGE_PASSWORD, element: <SetNewPasswordPage /> },
        ],
    },
    {
        path: PATH.DASHBOARD,
        element: <DashboardPage />,
    },
]);
